import templateUrl from "./page-content-count.html";

export const pageContentCountComponent = {
  bindings: {
    currentItemCount: "<",
    itemPerPage: "<",
    currentPage: "<",
    totalItems: "<",
  },

  templateUrl,

  controller: class PageContentCountComponent {
    $onInit() {
      this.currentTotalItems = `${
        this.itemPerPage * (this.currentPage - 1) + 1
      } - ${this.itemPerPage * (this.currentPage - 1) + this.currentItemCount}`;
    }

    $onChanges() {
      this.$onInit();
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/common/components/page-content-count/page-content-count.component.js